import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { DropdownAppAction } from "../../../../widget/common/ui/Dropdown";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import { NoticesListContextImport } from "../../../../provider/notices/notices_list/NoticesListContextProvider";

const NoticesListActions = () => {
  const {
    showSearch,
    updateShowSearch,
    longPressStatus,
    handleClickDeleteConfirm,
  } = NoticesListContextImport();

  return (
    <>
      {longPressStatus ? (
        <IconNormal
          name="delete2"
          color={AppTheme.themeFont}
          handleClick={handleClickDeleteConfirm}
        />
      ) : (
        <>
          {!showSearch && (
            <IconNormal
              name="magnify"
              color={AppTheme.themeFont}
              handleClick={() => updateShowSearch()}
            />
          )}
          <DropdownAppAction
            icon="more"
            options={[
              {
                title: "following",
                onClick: () => navigate(appRoutes.routeNameNoticesFollowing),
              },
            ]}
          />
        </>
      )}
    </>
  );
};

export default NoticesListActions;
